import _ from 'lodash'
import parseKeyValue from 'parse-key-value'

function toEvent(event) {
    if (typeof event == 'string') {
        event = {
            action: {
                type: event,
                application: event.split('.')[0]
            }
        }
    }
    return event
} 

function loadSettings(settings) {
    if (!settings) {
        let user = JSON.parse(localStorage.getItem('user'))
        if (!user || !user.accounts) return
    
        let domain = localStorage.getItem('domain')
        let { account } = user.accounts.find(userAccount => userAccount.account.domain == domain && userAccount.api && userAccount.service == 'reports')
    
        settings = account.settings
    }
    if (settings) {
        settings = _.cloneDeep(settings)
        if (settings.icons && settings.icons.events) settings.icons.events = parseKeyValue(settings.icons.events)
        if (settings.icons && settings.icons.tags) settings.icons.tags = parseKeyValue(settings.icons.tags)
        if (settings.timescale) settings.timescale = parseKeyValue(settings.timescale)
        if (settings.display) settings.display = parseKeyValue(settings.display)
    }
    return settings || {}
}

let lang = localStorage.getItem('lang') || 'en'
export default {
    state: {
        icons: {
            events: {
                'voip': 'phone',
                'voip.call': 'phone',
                'voip.ring': 'volume-up',
                'data': 'database',
                'mail': 'envelope',
                'mail.message': 'mail-bulk',
                'mail.send': 'envelope',
                'mail.mention': 'comments',
                'mail.clicked': 'paper-plane',
                'mail.reply': 'reply',
                'sms': 'comment',
                'shortener': 'anchor',
                'analytics': 'globe-americas',
                'analytics.info': 'info-circle',
                'analytics.view': 'globe-americas',
            },
            tags: {
                'desktop': 'desktop',
                'phone': 'mobile-alt',
                'tablet': 'tablet-alt',
            }
        },
        display: {
        },
        identities: ['name', 'phone', 'email'],
        agenda: {
            actions: ['mail.send', 'voip', 'data', 'mail.mention']
        },
        eventPriorities: ['voip.call', 'voip.ring', 'analytics.info', 'analytics.view'],
        settings: loadSettings(),
        lang
    },
    getters: {
        eventIcon: state => event => {
            event = toEvent(event)
            let settings = state.settings || {}
            let icon
            if (settings.icons && settings.icons.events) {
                icon = settings.icons.events[event.action.type] || settings.icons.events[event.action.application]
            }
            return icon || state.icons.events[event.action.type] || state.icons.events[event.action.application]
        },
        tagIcon: state => tag => {
            let settings = state.settings || {}
            let icon
            if (settings.icons && settings.icons.tags) {
                icon = settings.icons.tags[tag]
            }
            return icon || state.icons.tags[tag]
        },
        isBusiness: state => event => {
            // return true
            event = toEvent(event)
            let settings = state.settings || {}
            if (settings.agenda && settings.agenda.actions) {
                return true && (settings.agenda.actions.indexOf(event.action.type) > -1 || settings.agenda.actions.indexOf(event.action.application) > -1)
            }
            return true && (state.agenda.actions.indexOf(event.action.type) > -1 || state.agenda.actions.indexOf(event.action.application) > -1)
        },
        identities: state => () => {
            return state.settings.identities || state.identities
        },
        timescale: state => (event, scale) => {
            if (!state.settings || !state.settings.timescale || !state.settings.timescale[event.action.type]) return true
            let order = ['sec', 'min', 'hour', 'day', 'month', 'year']
            
            let result = order.indexOf(scale || 'min') >= order.indexOf(state.settings.timescale[event.action.type]) 
            return result
        },
        actionTitle: () => event => {
            event = toEvent(event)
            let title = event.action.type.split(/[._]/).map(_.capitalize).join(' ').replace('Url Query ', '')
            return title
        }
    },
    mutations: {
        updateSettings(state, settings) {
            state.settings = settings || {}
        },
        updatePreferences(state, preferences) {
            _.merge(state.preferences, preferences)
            localStorage.setItem('settings.preferences', JSON.stringify(state.preferences))
        },
        updateLang(state, lang) {
            localStorage.setItem('lang', lang)
            state.lang = lang
        }
    },
    actions: {
        reloadFilter({ commit, state }, filters) {
            let preferences = {
                filters: {
                    blacklist: [...state.filter.blacklist],
                    default: filters.filter(f => !state.filter.blacklist.some(f)),
                }
            } 
            commit('updatePreferences', preferences)
        },
        whitelistFilter({commit, state }, filter) {
            let preferences = {
                filter: {
                    blacklist: [...state.filter.blacklist.filter(f => f == filter)],
                    default: [...state.filter.default, filter],
                }
            }
            commit('updatePreferences', preferences)
        },
        blacklistFilter({commit, state }, filter) {
            let preferences = {
                filter: {
                    blacklist: [...state.filter.blacklist, filter],
                    default: [...state.filter.default.filter(f => f == filter)],
                }
            }
            commit('updatePreferences', preferences)
        },
        reloadSettings({ commit }, settings) {
            commit('updateSettings', loadSettings(settings))            
        },
        clearSettings({ commit }) {
            commit('updateSettings', {})    
        },
        setDefaultLang({ commit }, lang) {
            if (!localStorage.getItem('lang')) {
                commit('updateLang', lang)
            }
        },
        setLang({ commit }, lang) {
            commit('updateLang', lang)
        },
    }
}